import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

import SelectionBar from '../components/selection/SelectionBar'
import Button from '../components/Button'
import ButtonRun from '../components/ButtonRun'
import GridHeader from '../components/GridHeader'
import ButtonUpload from '../components/ButtonUpload'
import ButtonDownload from '../components/ButtonDownload'
import ButtonRunDownload from '../components/ButtonRunDownload'
import GridCircularProgress from '../components/GridCircularProgress'
import { useGetBackendRQuery, useGetIscrizioniQuery } from '../hooks/api-slice'
import { config } from '../settings/configs'

// isolate polling to avoid re-rendering of upload button and log dialog
const BackendRStatus = () => {
  const optimisticBackendR = useSelector(state => state.home.optimisticBackendR)

  const [pollingInterval, setPollingInterval] = useState()

  const { data: backendR } = useGetBackendRQuery(undefined, { pollingInterval })

  const backendRR = optimisticBackendR || backendR
  const isBusy = backendRR?.status === 'busy'
  const isAvailable = backendRR?.status === 'available'

  useEffect(() => {
    setPollingInterval(isAvailable ? 10_000 : 3_000)
  }, [isAvailable])

  return (
    <>
      <GridHeader>
        {(isAvailable && 'Algoritmi pronti a partire!') ||
          (isBusy && `${backendRR?.process} in esecuzione...`) ||
          'Lo stato degli algoritmi è sconosciuto.'}
      </GridHeader>
      {isBusy && <GridCircularProgress />}
    </>
  )
}

const Algoritmi = () => {
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const { data: iscrizioniLight } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'light' },
    { skip: !selectedCampionato },
  )
  const availableCategorie = useSelector(
    state => state.selection.availableCategorie,
  )
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )

  document.title = `${config?.name} - Algoritmi`

  const Arrow = () => {
    return (
      <Grid size='grow'>
        <center>
          <ArrowDownwardIcon />
        </center>
      </Grid>
    )
  }

  const GridColumn = ({ algorithm, title }) => {
    return (
      <Grid size={{ xs: 12, md: 4 }}>
        <Grid container spacing={1} alignItems='center' sx={{ width: '100%' }}>
          <GridHeader h2 text={title} />
          {['01_GenerateTable'].includes(algorithm) && (
            <Grid size={12}>
              <center>
                <Button transparent>
                  {iscrizioniLight?.filter(i =>
                    selectedCategoria &&
                    selectedCategoria !== availableCategorie[0]
                      ? i.categoria === selectedCategoria
                      : true,
                  )?.length || 0}{' '}
                  squadre iscritte
                </Button>
              </center>
            </Grid>
          )}
          {['02_GenerateGironi', '03_GenerateCalendari'].includes(
            algorithm,
          ) && (
            <Grid size={12}>
              <ButtonUpload
                buttonText='Carica CSV'
                algorithm={algorithm}
                fileName='Input'
              />
            </Grid>
          )}
          <Grid size={12}>
            <Arrow />
          </Grid>
          <Grid size={12}>
            <ButtonRun
              buttonText={`Genera ${
                (algorithm === '01_GenerateTable' && 'tabella iscrizioni') ||
                (algorithm === '02_GenerateGironi' && 'gironi') ||
                (algorithm === '03_GenerateCalendari' && 'calendari') ||
                algorithm
              }`}
              algorithm={algorithm}
            />
          </Grid>
          <Grid size={12}>
            <Arrow />
          </Grid>
          {[
            '01_GenerateTable',
            '02_GenerateGironi',
            '03_GenerateCalendari',
          ].includes(algorithm) && (
            <Grid size={12}>
              <ButtonDownload algorithm={algorithm} type='TXT' />
            </Grid>
          )}
          <Grid size={12}>
            <ButtonDownload algorithm={algorithm} type='CSV' />
          </Grid>
          {['02_GenerateGironi', '03_GenerateCalendari'].includes(
            algorithm,
          ) && (
            <Grid size={12}>
              <ButtonDownload algorithm={algorithm} type='PDF' />
            </Grid>
          )}
          {['03_GenerateCalendari'].includes(algorithm) && (
            <Grid size={12}>
              <ButtonDownload algorithm={algorithm} type='XLSX' />
            </Grid>
          )}
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container paddingX={2} spacing={2} sx={{ width: '100%' }}>
      <GridHeader h2 text='Algoritmi' />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar data={iscrizioniLight} yCampionato yCategoria />
      </Grid>
      <BackendRStatus />
      <Grid container alignItems='flex-start' sx={{ width: '100%' }}>
        <GridColumn algorithm='01_GenerateTable' title='Iscrizioni' />
        <GridColumn algorithm='02_GenerateGironi' title='Gironi' />
        <GridColumn algorithm='03_GenerateCalendari' title='Calendari' />
      </Grid>
      <Grid size={12}>
        <ButtonRunDownload
          buttonText='Stats'
          algorithm='11_ComputeStats'
          triggerDownload
          type='TXT'
          disabled={!selectedCampionato}
        />
      </Grid>
    </Grid>
  )
}

export default Algoritmi
